<template>
  <AdminCrudPage
    collection-name="reviews"
    title="Reviews"
    singular-title="Review"
    :fields="fields"
    :columns="columns"
    :seed-data="seedData"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'

export default {
  name: 'AdminReviews',
  components: { AdminCrudPage },
  data() {
    return {
      columns: [
        { key: 'name', label: 'Name' },
        { key: 'location', label: 'Location' },
        { key: 'rating', label: 'Rating' }
      ],
      fields: [
        { key: 'name', label: 'Name', type: 'text', required: true },
        { key: 'location', label: 'Location (e.g. "Karachi, PK")', type: 'text' },
        { key: 'message', label: 'Review Message', type: 'textarea' },
        { key: 'avatar', label: 'Avatar Photo', type: 'image' },
        { key: 'rating', label: 'Rating (1-5)', type: 'number', default: 5 }
      ],
      seedData: [
        {
          name: 'Ayesha Siddiqui',
          location: 'Manchester, UK',
          message: '"Exceptionally responsive team! They managed to book business-class tickets even during the peak Ramadan rush and went the extra mile by arranging a dedicated."',
          avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
          rating: 5
        },
        {
          name: 'Imran Qureshi',
          location: 'Karachi, PK',
          message: '"Our youth group of 18 people had everything arranged—visa, hotels, and a Hunza tour after Umrah. Truly stress-free."',
          avatar: 'https://randomuser.me/api/portraits/men/75.jpg',
          rating: 5
        },
        {
          name: 'Sara Khan',
          location: 'Doha, QA',
          message: '"Loved the concierge service. They surprised my parents with dates & Zamzam gift baskets in the hotel room."',
          avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
          rating: 5
        }
      ]
    }
  }
}
</script>
